import {Injectable} from '@angular/core';
import {
  LoadingController,
  ToastController,
  ToastOptions,
  LoadingOptions,
  AlertController,
  AlertOptions, ActionSheetOptions, ActionSheetController, ModalController, ModalOptions,
  PickerController, PickerOptions,
} from "@ionic/angular";

import {Keyboard, KeyboardPlugin} from '@capacitor/keyboard';
import {Capacitor, PluginListenerHandle} from "@capacitor/core";
import {StatusBar, StatusBarPlugin} from "@capacitor/status-bar";

import {from, Observable, ObservedValueOf} from "rxjs";

import {StandardResponse} from "@interfaces/general.types";
import {timestamp} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class UiHelperService {
  public isBanner: boolean = false;
  public isBannerShownOnCurrentPage: boolean = true;
  private _showBackButton: boolean = true
  public keyboard: KeyboardPlugin | undefined;
  public statusBar: StatusBarPlugin | undefined;
  private _showFooter: boolean = true;
  onKeyboardShow: Observable<ObservedValueOf<Promise<PluginListenerHandle> & PluginListenerHandle>> | undefined;
  public isKeyboardOpen: boolean = false;

  get showBackButton(): boolean {
    return this._showBackButton;
  }

  set showBackButton(value: boolean) {
    this._showBackButton = value;
  }

  get showFooter(): boolean {
    return this._showFooter;
  }

  set showFooter(value: boolean) {
    this._showFooter = value;
  }

  constructor(
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private actionCtrl: ActionSheetController,
    private modalCtrl: ModalController,
    private pickerCtrl: PickerController,
  ) {
    if (Capacitor.isPluginAvailable('Keyboard')) {
      Keyboard.addListener('keyboardWillShow', () => {
        this.isKeyboardOpen = true;
      })
      Keyboard.addListener('keyboardDidHide', () => {
        this.isKeyboardOpen = false;
      })
      this.keyboard = Keyboard;
      this.onKeyboardShow = from(Keyboard.addListener('keyboardWillShow', () => {
      }));
    }
    if (Capacitor.isPluginAvailable('StatusBar')) {
      this.statusBar = StatusBar;
    }
  }

  /**
   * Displays a toast popup.
   * @param options - The {@link ToastOptions} passed to be used.
   * @returns response - A standard response.
   */
  presentToast(options?: ToastOptions): StandardResponse {
    this.toastCtrl.create(options).then(toast => toast.present());
    return {success: true, message: 'toast displayed'};
  }

  /**
   * Creates a loader if one is not already present.
   * @param options - The {@link LoadingOptions} to be used. Defaults to {text: ' אנא המתן...'}.
   * @returns response - A Standard response.
   */
  presentLoader(options?: LoadingOptions) {
    options = {backdropDismiss: true, ...options}
    this.loadingCtrl.getTop().then(res => {
        if (!res) {
          this.loadingCtrl.create(options).then((loader) => {
            loader.present().then(() => {
            }).catch()
          })
            .catch()
        }
      }
    ).catch()
  }


  /**
   * Hides a loader if one exists
   */
  hideLoader() {
    let times = 0;
    let interval = setInterval(() => {
      this.loadingCtrl.getTop().then(res => {
        res?.dismiss().then(() => {

        }).catch()
      })
      times++
      times > 6 ? clearInterval(interval) : '';
    }, 150);
  }

  /**
   * Displays an showAlert popup.
   * @param options - The {@link AlertOptions} passed to be used.
   */
  presentAlert(options: AlertOptions) {
    this.alertCtrl.create(options).then(alert => alert.present())
  }

  /**
   * Displays an action sheet popup.
   * @param options - The {@link ActionSheetOptions} passed to be used.
   * @types {{options: ActionSheetOptions}=> response:StandardResponse}
   */
  presentActionSheet(options: ActionSheetOptions) {
    this.actionCtrl.create(options).then(actionSheet => actionSheet.present())
  }

  /**
   * Displays a modal control.
   * @param options
   */
  async createModal(options: ModalOptions): Promise<HTMLIonModalElement> {
    return await this.modalCtrl.create(options);
  }

  /**
   * dismisses all modals.
   * @param item - The data returned to the caller.
   */
  dismissModals(item?: any) {
    this.modalCtrl.dismiss(item).then()
  }

  async createPicker(options: PickerOptions): Promise<any> {
    return await this.pickerCtrl.create(options)
  }

  async showPicker(picker:any) {
    await picker.present();
  }

  async dismissPicker(picker:any) {
    return await picker.onWillDismiss();
  }

  dismissToast() {
    this.toastCtrl.dismiss().then().catch();
  }
}
